import {
  DispenserTimelineDetailItem,
  DispenserTimelineItem,
} from '@/features/dispensers/services/schemas.ts';

export function mapTimelineDetailItemToTimelineItem(
  timelineDetailItem: DispenserTimelineDetailItem
): DispenserTimelineItem {
  return {
    id: timelineDetailItem.id,
    eventType: timelineDetailItem.eventType,
    result: timelineDetailItem.result,
    startTime: timelineDetailItem.eventAt,
    endTime: timelineDetailItem.eventAt,
    startTimeUtcOffset: timelineDetailItem.utcOffset,
    endTimeUtcOffset: timelineDetailItem.utcOffset,
    eventsCount: 1,
    resultsErrorCount: 0,
    payload: timelineDetailItem.payload,
  };
}
